// Max allowed height of the list item container
export const DROPDOWN_CONTAINER_MAX_HEIGHT_DESKTOP = 320;
export const DROPDOWN_CONTAINER_MAX_HEIGHT_MOBILE = 224;

export const dropdownDirection = (
  parentEl: HTMLElement,
  el: HTMLElement,
  containerHeightType: 'desktop' | 'mobile'
): 'up' | 'down' => {
  const screenHeight = document.documentElement.clientHeight;
  const { top: offsetTop, height: parentElHeight } = parentEl.getBoundingClientRect();
  const innerMaxHeight =
    containerHeightType === 'desktop' ? DROPDOWN_CONTAINER_MAX_HEIGHT_DESKTOP : DROPDOWN_CONTAINER_MAX_HEIGHT_MOBILE;
  let innerHeightOffset = el.offsetHeight;
  innerHeightOffset = innerHeightOffset > innerMaxHeight ? innerMaxHeight : innerHeightOffset;
  return screenHeight - innerHeightOffset - parentElHeight - 4 > offsetTop ? 'down' : 'up';
};
